module.exports = __webpack_public_path__ + "media/assets/images/cloudy_sometime_will_snow-27b6e6de4841769ec1e6e9badde07390.png";